/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestScenarioDto } from "./QuoteTestScenarioDto";
import {
  QuoteTestScenarioDtoFromJSON,
  QuoteTestScenarioDtoFromJSONTyped,
  QuoteTestScenarioDtoToJSON,
  QuoteTestScenarioDtoToJSONTyped,
} from "./QuoteTestScenarioDto";
import type { QuoteTestExpectationDto } from "./QuoteTestExpectationDto";
import {
  QuoteTestExpectationDtoFromJSON,
  QuoteTestExpectationDtoFromJSONTyped,
  QuoteTestExpectationDtoToJSON,
  QuoteTestExpectationDtoToJSONTyped,
} from "./QuoteTestExpectationDto";
import type { QuoteTestGroupMetadata } from "./QuoteTestGroupMetadata";
import {
  QuoteTestGroupMetadataFromJSON,
  QuoteTestGroupMetadataFromJSONTyped,
  QuoteTestGroupMetadataToJSON,
  QuoteTestGroupMetadataToJSONTyped,
} from "./QuoteTestGroupMetadata";

/**
 *
 * @export
 * @interface QuoteTestGroupDto
 */
export interface QuoteTestGroupDto {
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  groupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestGroupDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  serviceIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroupDto
   */
  metadata?: string;
  /**
   *
   * @type {Array<QuoteTestExpectationDto>}
   * @memberof QuoteTestGroupDto
   */
  expectations: Array<QuoteTestExpectationDto>;
  /**
   *
   * @type {Array<QuoteTestScenarioDto>}
   * @memberof QuoteTestGroupDto
   */
  scenarios: Array<QuoteTestScenarioDto>;
  /**
   *
   * @type {QuoteTestGroupMetadata}
   * @memberof QuoteTestGroupDto
   */
  parsedMetadata: QuoteTestGroupMetadata;
}

/**
 * Check if a given object implements the QuoteTestGroupDto interface.
 */
export function instanceOfQuoteTestGroupDto(
  value: object,
): value is QuoteTestGroupDto {
  if (!("expectations" in value) || value["expectations"] === undefined)
    return false;
  if (!("scenarios" in value) || value["scenarios"] === undefined) return false;
  if (!("parsedMetadata" in value) || value["parsedMetadata"] === undefined)
    return false;
  return true;
}

export function QuoteTestGroupDtoFromJSON(json: any): QuoteTestGroupDto {
  return QuoteTestGroupDtoFromJSONTyped(json, false);
}

export function QuoteTestGroupDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestGroupDto {
  if (json == null) {
    return json;
  }
  return {
    groupId: json["groupId"] == null ? undefined : json["groupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    expectations: (json["expectations"] as Array<any>).map(
      QuoteTestExpectationDtoFromJSON,
    ),
    scenarios: (json["scenarios"] as Array<any>).map(
      QuoteTestScenarioDtoFromJSON,
    ),
    parsedMetadata: QuoteTestGroupMetadataFromJSON(json["parsedMetadata"]),
  };
}

export function QuoteTestGroupDtoToJSON(json: any): QuoteTestGroupDto {
  return QuoteTestGroupDtoToJSONTyped(json, false);
}

export function QuoteTestGroupDtoToJSONTyped(
  value?: QuoteTestGroupDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    groupId: value["groupId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    title: value["title"],
    description: value["description"],
    metadata: value["metadata"],
    expectations: (value["expectations"] as Array<any>).map(
      QuoteTestExpectationDtoToJSON,
    ),
    scenarios: (value["scenarios"] as Array<any>).map(
      QuoteTestScenarioDtoToJSON,
    ),
    parsedMetadata: QuoteTestGroupMetadataToJSON(value["parsedMetadata"]),
  };
}
